import { render, staticRenderFns } from "./PostAdmin.vue?vue&type=template&id=8ac36d80&scoped=true"
import script from "./PostAdmin.vue?vue&type=script&lang=js"
export * from "./PostAdmin.vue?vue&type=script&lang=js"
import style0 from "./PostAdmin.vue?vue&type=style&index=0&id=8ac36d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac36d80",
  null
  
)

export default component.exports